import { render, staticRenderFns } from "./CopyTemplateModal.vue?vue&type=template&id=57965fb3&"
import script from "./CopyTemplateModal.vue?vue&type=script&lang=js&"
export * from "./CopyTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports